import type { Dayjs } from 'dayjs'

// Treat the picked calendar date as a UTC day. `Dayjs.toISOString()` would
// shift it into the previous day for users west of UTC.
export function toIsoBoundary(date: Dayjs, edge: 'start' | 'end'): string {
  const day = date.format('YYYY-MM-DD')
  return edge === 'start' ? `${day}T00:00:00.000Z` : `${day}T23:59:59.999Z`
}
